import About from './components/about/about'
import Header from './components/header/header'
import Nav from './components/nav/nav'
import Experience from './components/experience/experience'
import Publication from './components/publication/publication'
import Footer from './components/footer/footer'
import Award from './components/award/award'
import Service from './components/service/service'

const App = () => {
  return (
    <div className="site-shell">
      <Header />
      <main className="site-main">
        <Nav />
        <About />
        <Experience />
        <Publication />
        <Service />
        <Award />
        <Footer />
      </main>
    </div>
  )
}

export default App
